// The rule for new passwords, as the server checks it
// (backend/services/passwordRules.js). Signing in doesn't check it, so older,
// shorter passwords keep working.
export const MIN_PASSWORD_LENGTH = 8;
export const PASSWORD_HINT = `At least ${MIN_PASSWORD_LENGTH} characters`;

export function passwordProblem(password) {
  return (password || '').length < MIN_PASSWORD_LENGTH
    ? `Password must be at least ${MIN_PASSWORD_LENGTH} characters long`
    : null;
}
